import { render, staticRenderFns } from "./QuestionsViewer.vue?vue&type=template&id=f97bfc86&"
import script from "./QuestionsViewer.vue?vue&type=script&lang=js&"
export * from "./QuestionsViewer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports